module.exports = __webpack_public_path__ + "static/assets/0b8b19ce97a69a7bf2fca5fc35fb33af.svg";